import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
  CheckoutRoutes,
  CmsLandingPage,
  SignInForm,
  SignInFormValue,
} from '@checkout/util-models';
import { AuthFacade } from '@domgen/dgx-fe-authentication';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, combineLatest, filter, first, mergeMap, tap } from 'rxjs';
export interface ViewModel {
  cmsData: CmsLandingPage;
}

export interface ComponentState {
  form?: FormGroup<SignInForm>;
}

@Injectable()
export class LandingComponentService extends ComponentStore<ComponentState> {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(
    private readonly authFacade: AuthFacade,
    private readonly cmsContainer: CmsContainer<CmsLandingPage>,
    private readonly router: Router
  ) {
    super({});
  }

  onFormSubmit = this.effect((signInFormValue$: Observable<SignInFormValue>) =>
    signInFormValue$.pipe(
      filter(({ email, password }) => Boolean(email) && Boolean(password)),
      tap((signInFormValue) => {
        this.authFacade.signIn({
          email: signInFormValue.email,
          password: signInFormValue.password,
        } as {
          email: string;
          password: string;
        });
      }),
      mergeMap(() => this.authFacade.userLoaded$),
      filter(Boolean),
      first(),
      tap(() => this.router.navigateByUrl(CheckoutRoutes.PaymentMethod))
    )
  );
}
